import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Camera } from 'lucide-react';
interface Props {
  onNext: () => void;
}
const suggestions = ['Ask an expert something', 'Show us behind the scenes', 'Capture a booth moment', 'What’s creating buzz?', 'Show us the customer perspective'];
export const Screen6Video = ({
  onNext
}: Props) => {
  const [value, setValue] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = () => {
    if (!value.trim()) return;
    setSubmitted(true);
    setTimeout(onNext, 1500);
  };
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-413">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-red-950/20 to-slate-950" data-id="element-414" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-415">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-red-500 font-semibold mb-4" data-id="element-416">
          06 — Ask The Team
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-3xl font-bold text-white leading-tight mb-4" data-id="element-417">
          Put the ERA team to work.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="text-slate-400 mb-8" data-id="element-418">
          What should we capture for you?
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="mb-6" data-id="element-419">
          <textarea value={value} onChange={e => setValue(e.target.value)} disabled={submitted} className="w-full bg-slate-900/60 border border-slate-800 focus:border-red-500/60 rounded-2xl p-4 text-white text-base leading-relaxed resize-none focus:outline-none transition-colors placeholder:text-slate-600 h-32" placeholder="Type your request here..." data-id="element-420" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="flex-1" data-id="element-421">
          <p className="text-xs text-slate-500 uppercase tracking-wider mb-3" data-id="element-422">
            Ideas:
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-423">
            {suggestions.map((s, i) => <button key={i} onClick={() => setValue(s)} disabled={submitted} className="text-xs bg-slate-900 border border-slate-800 text-slate-400 px-3 py-1.5 rounded-full hover:bg-slate-800 hover:text-slate-300 transition-colors text-left" data-id="element-424">
                {s}
              </button>)}
          </div>
        </motion.div>

        <div className="mt-auto pt-6" data-id="element-425">
          <AnimatePresence data-id="element-426">
            {submitted && <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0
          }} className="text-center text-sm text-red-400 mb-4 italic flex items-center justify-center space-x-2" data-id="element-427">
                <Camera className="w-4 h-4" data-id="element-428" />
                <span data-id="element-429">We're on it.</span>
              </motion.div>}
          </AnimatePresence>

          <button onClick={handleSubmit} disabled={!value.trim() || submitted} className="w-full bg-red-600 hover:bg-red-500 disabled:bg-slate-800 disabled:text-slate-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-430">
            <span data-id="element-431">{submitted ? 'Sent ✓' : 'Send request'}</span>
            {!submitted && <ArrowRight className="w-5 h-5" data-id="element-432" />}
          </button>
        </div>
      </div>
    </div>;
};